import pathToRegexp from 'path-to-regexp';
import ROUTES from './reportRoutes';

const toProductSalesPath = pathToRegexp.compile(ROUTES.PRODUCT_SALES_REPORT);
const toSalesOverviewPath = pathToRegexp.compile(ROUTES.SALES_REPORT);
const toServiceSalesPath = pathToRegexp.compile(ROUTES.SERVICE_SALES_REPORT);

type DateAndEmployeeFilters = {
  fromDate: string;
  toDate: string;
  employeeFilter: number;
};

export type ChannelReportFilterChange = DateAndEmployeeFilters & {
  bookingChannel: string;
};

const withEmployeeSegment = ({ fromDate, toDate, employeeFilter }: DateAndEmployeeFilters) => ({
  fromDate,
  toDate,
  employeeFilter: String(employeeFilter),
});

export const buildProductSalesReportPath = (
  venueId: string,
  filters: DateAndEmployeeFilters,
): string =>
  toProductSalesPath({
    venueId,
    ...withEmployeeSegment(filters),
  });

const channelReportPath = (toPath: typeof toSalesOverviewPath) => (
  venueId: string,
  { bookingChannel, ...filters }: ChannelReportFilterChange,
): string =>
  toPath({
    venueId,
    ...withEmployeeSegment(filters),
    selectedChannel: bookingChannel,
  });

export const buildSalesOverviewReportPath = channelReportPath(toSalesOverviewPath);
export const buildServiceSalesReportPath = channelReportPath(toServiceSalesPath);
